const MAX_SIDE = 2400;
const SKIP_BELOW = 700 * 1024;

/**
 * Phone photos are often 4–10 MB; shrink them to a 2400 px JPEG before upload so field uploads
 * over mobile data stay quick. PDFs and small images are returned unchanged; on any failure the
 * original file is used.
 */
export async function shrinkImage(file) {
    if (!file?.type?.startsWith('image/') || file.size < SKIP_BELOW || typeof createImageBitmap !== 'function') return file;
    try {
        const bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
        const scale = Math.min(1, MAX_SIDE / Math.max(bitmap.width, bitmap.height));
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(bitmap.width * scale);
        canvas.height = Math.round(bitmap.height * scale);
        canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);
        bitmap.close?.();
        const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', 0.85));
        if (!blob || blob.size >= file.size) return file;
        const name = file.name.replace(/\.[^.]+$/, '') + '.jpg';
        return new File([blob], name, { type: 'image/jpeg', lastModified: Date.now() });
    } catch {
        return file;
    }
}
